(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadSwiperAssets(callback) {
    var cssHref = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css';
    var jsHref = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js';

    if (!document.querySelector('link[href="' + cssHref + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
    }

    if (window.Swiper) { callback(); return; }

    if (document.querySelector('script[data-swiper-loader]')) {
      var wait = setInterval(function () {
        if (window.Swiper) { clearInterval(wait); callback(); }
      }, 50);
      return;
    }

    var script = document.createElement('script');
    script.src = jsHref;
    script.setAttribute('data-swiper-loader', 'true');
    script.onload = function () { callback(); };
    document.head.appendChild(script);
  }

  function initCarousel(container) {
    if (!container) return;
    if (container.dataset.initialized === 'true') return;

    var paginationEl = container.querySelector('.swiper-pagination');

    try {
      new Swiper(container, {
        loop: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 16,
        pagination: { el: paginationEl, clickable: true },
        autoplay: { delay: 4000, disableOnInteraction: false },
        breakpoints: { 
          // Tablet: 2 visible slides
          768: { 
            spaceBetween: 20
          },
          // Laptop: 3 visible slides
          1024: {
            spaceBetween: 24
          }
        },
        on: { init: function () { container.dataset.initialized = 'true'; } }
      });
    } catch (e) {
      console.error('Swiper init error:', e);
    }
  }
  
  document.addEventListener('shopify:section:load', function(event) {
    var container = event.target.querySelector('.testimonial-swiper');
    if (container) {
      loadSwiperAssets(function () {
        initCarousel(container);
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var containers = document.querySelectorAll('.testimonial-swiper');
    if (!containers.length) return;
    loadSwiperAssets(function () {
      containers.forEach(initCarousel);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
